module.exports = __webpack_public_path__ + "tz.64cddc3f1df7011e2f4a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tz.svg
// module chunks = styles